<template>
    <div class="p-2">
        <h2>{{ $t("Staff") }}</h2>
        <div class="grid grid-cols-3 p-1" v-for="staffer in $page.props.staffList">
            <div class="col-span-2">
                {{ staffer.mName }}
            </div>
            <div class="col-span-1 text-xs text-white/50">
                <span v-if="staffer.status"><i class="fa-solid fa-circle text-green-600"></i> Online</span>
                <span v-else><i class="fa-solid fa-circle text-red-600"></i> Offline</span>
            </div>
        </div>
    </div>
</template>
